import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Cookies from 'js-cookie';

import * as uiActions from '../actions/ui';

import { VOUCHER_STATUS_APPLIED, VOUCHER_STATUS_INVALID } from '../constants';

class Discover extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isSpecialOfferRoute: PropTypes.bool.isRequired,
    showModal: PropTypes.func.isRequired,
  };

  componentDidMount = async () => {
    const { isSpecialOfferRoute, showModal } = this.props;

    if (isSpecialOfferRoute) {
      const voucherCookie = Cookies.get('_idagio-voucher');

      if (voucherCookie) {
        const voucherStatus = JSON.parse(voucherCookie).status;

        if (voucherStatus === VOUCHER_STATUS_APPLIED) {
          showModal('VOUCHER_SUCCESS_MODAL');
        } else if (voucherStatus === VOUCHER_STATUS_INVALID) {
          showModal('VOUCHER_MODAL', { trigger: 'invalidVoucher' });
        }

        Cookies.remove('_idagio-voucher');
      }
    }
  };

  render() {
    return (
      <div className="u-page-container" data-test="discover-page">
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { location } = ownProps;

  return {
    isSpecialOfferRoute: location.pathname === 'special-offer',
  };
}

export default compose(
  withRouter,
  connect(mapStateToProps, { showModal: uiActions.showModal })
)(Discover);
